export function initBootSplash(root: HTMLElement): HTMLElement {
  const splash = document.createElement('div');
  splash.id = 'boot-splash';
  splash.className = 'is-hidden';
  splash.inert = true;
  const line = document.createElement('div');
  line.textContent = 'Starting Ben95...';
  const sub = document.createElement('div');
  sub.textContent = 'Do not turn off your beige box.';
  splash.append(line, sub);
  root.append(splash);
  return splash;
}
